
import store from "../store";
const initialState = [
  {
    title: "Dashboard",
    href: "/dashboard",
    icon: "BarChartIcon",
    checked: true,
  },
  { title: "Theme", href: "/theme", icon: "SettingsIcon", checked: true },
  { title: "Calendar", href: "/calendar", icon: "CalendarIcon", checked: true },
  {
    title: "Messages",
    href: "/messages",
    icon: "NotificationsIcon",
    checked: true,
  },
  {
    title: "Learning Path",
    href: "/learning-path",
    icon: "SettingsIcon",
    checked: true,
  },
  { title: "Users", href: "/user", icon: "UsersIcon" },
  {
    title: "Communications",
    href: "/communications",
    icon: "CommunicationIcon",
    checked: true,
  },
  { title: "Courses", href: "/courses", icon: "CourseIcon", checked: true },
  {
    title: "Classroom",
    href: "/classroom",
    icon: "CalendarIcon",
    checked: true,
  },
  {
    title: "Assessment",
    href: "/assessment",
    icon: "AlertCircleIcon",
    checked: true,
  },
  {
    title: "Announcements",
    href: "/announcements",
    icon: "BarChartIcon",
    checked: true,
  },
  {
    title: "Discussions",
    href: "/discussions",
    icon: "AlertCircleIcon",
    checked: true,
  },
  {
    title: "Organization",
    href: "/organization",
    icon: "OrganizationIcon",
    checked: true,
    childrens: [
      {
        title: "Human Resource",
        href: "/organization/human-resource",
        icon: "",
        checked: true,
      },
      {
        title: "Video Conferencing",
        href: "/videoConference",
        icon: "",
        checked: true,
      },
      {
        title: "Cerification",
        href: "/organization/cerification",
        icon: "",
        checked: true,
      },
      {
        title: "Reports",
        href: "/organization/reports",
        icon: "",
        checked: true,
      },
      {
        title: "Event Engine",
        href: "/organization/event-engine",
        icon: "",
        checked: true,
      },
      {
        title: "Tools & Plugins",
        href: "/organization/tools-plugins",
        icon: "",
        checked: true,
      },
    ],
  },
];

export const filterItems = (state, role, is_active) => {
  return state.filter((item) => is_active);
};

const LOAD_NAV = "LOAD_NAV";
export const loadNavAction = () => ({
  type: LOAD_NAV,
  role: store.getState().session.role.name,
  is_active: store.getState().session.is_active,
});

export const loadNav = () => (dispatch) => {
  return dispatch(loadNavAction());
};

export default function navReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_NAV: {
      return filterItems(initialState, action.role, action.is_active);
    }
    default:
      return state;
  }
}
